module.exports = __webpack_public_path__ + "static/media/MSS.4b683955.png";